// // ExpertsPage.jsx
// import React, { useEffect, useState, useRef } from "react";
// import {
//   Container,
//   Card,
//   CardContent,
//   Typography,
//   Avatar,
//   Box,
//   TextField,
//   CircularProgress,
//   Link, 
//   ButtonBase
// } from "@mui/material";
// import axios from "axios";
// import Skeleton from "@mui/material/Skeleton";
// import Header1 from "../Header/Header1";
// import Footer2 from "../Footer/Footer2";
// import SearchIcon from "@mui/icons-material/Search";
// import InputAdornment from "@mui/material/InputAdornment";
// import { useAuth } from "../../AuthContext";
// import { useNavigate } from "react-router-dom";
// import Platform from "../Platform/Platform";

// const API_URL = process.env.REACT_APP_API_URL;
// const CHUNK_SIZE = 10;
// const FREE_USER_LIMIT = 8; // Limit for inactive subscription users

// const ExpertsPage = () => {
//   const { userId } = useAuth();
//   const { loggedIn } = useAuth();
//   const navigate = useNavigate();
//   const [experts, setExperts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [fetchingMore, setFetchingMore] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [subscription, setSubscription] = useState(null); // store subscription
//   const observer = useRef();

//   // Initialize subscription
//   const initSubscription = async () => {
//     try {
//       const { data } = await axios.post(`${API_URL}/subscriptions/init/`, {
//         user_id: userId,
//       });
//       setSubscription(data.subscription); // store subscription object
//     } catch (err) {
//       console.error("Failed to initialize subscription:", err);
//     }
//   };

//   // Load experts from backend
//   const loadExperts = async (pageNumber = 1, search = "") => {
//     if (!subscription) return; // wait until subscription is fetched
//     try {
//       if (pageNumber === 1) setLoading(true);
//       else setFetchingMore(true);

//       const { data } = await axios.get(`${API_URL}/experts/`, {
//         params: { page: pageNumber, limit: CHUNK_SIZE, search },
//       });

//       const newExperts = Array.isArray(data) ? data : data.experts || [];

//       // Respect free user limit for inactive subscriptions
//       const limitedExperts =
//         subscription.is_active === false
//           ? newExperts.slice(0, FREE_USER_LIMIT)
//           : newExperts;

//       if (pageNumber === 1) setExperts(limitedExperts);
//       else setExperts((prev) => [...prev, ...limitedExperts]);

//       setHasMore(
//         subscription.is_active
//           ? newExperts.length === CHUNK_SIZE
//           : false // inactive users cannot load more
//       );
//       setPage(pageNumber);
//     } catch (err) {
//       console.error("Failed to fetch experts:", err);
//     } finally {
//       setLoading(false);
//       setFetchingMore(false);
//     }
//   };

//   // Initial subscription check
//   useEffect(() => {
//     if (!userId) return;
//     initSubscription();
//   }, [userId]);

//   // Load experts after subscription is set or search term changes
//   useEffect(() => {
//     if (subscription) loadExperts(1, searchTerm);
//   }, [subscription, searchTerm]);

//   // Infinite scroll
//   const lastExpertRef = (node) => {
//     if (fetchingMore || subscription?.is_active === false) return; // inactive users can't load more
//     if (observer.current) observer.current.disconnect();
//     observer.current = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting && hasMore) {
//         loadExperts(page + 1, searchTerm);
//       }
//     });
//     if (node) observer.current.observe(node);
//   };

//   return (
//     <div>
      
//       <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1300 }}>
//               <Header1 />
//             </Box>
//        {loggedIn && <Platform />}
//       <Container maxWidth="lg" sx={{ py: 10, background: 'radial-gradient(circle at top, #1b1b2b 0%, #000000 100%)', }}>
//         {/* Heading */}
//         <Box sx={{ textAlign: "center", mb: 3 }}>
//           <Typography
//             variant="h3"
//             sx={{
//               fontWeight: 700,
//               letterSpacing: 4,
//               textTransform: "uppercase",
//               display: "inline-block",
//               position: "relative",
//               "&::after": {
//                 content: '""',
//                 position: "absolute",
//                 width: "60%",
//                 height: "4px",
//                 bottom: -8,
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 background: "linear-gradient(90deg, #1E90FF, #00C9FF)",
//                 borderRadius: 2,
//               },
//             }}
//           >
//             Our Experts
//           </Typography>
//         </Box>

//         {/* Search Bar */}
//         <Box sx={{ display: "flex", justifyContent: "center", mb: 4, px: 2 }}>
//           <TextField
//             placeholder="Search by name, designation, about, or expertise"
//             variant="outlined"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{
//               width: "100%",
//               maxWidth: 600,
//               bgcolor: "#111",
//               borderRadius: "50px",
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "50px",
//                 bgcolor: "#111",
//                 color: "white",
//                 transition: "0.3s",
//                 "&:hover": { bgcolor: "#222" },
//                 "&.Mui-focused": {
//                   boxShadow: "0 0 10px rgba(30, 144, 255, 0.6)",
//                   borderColor: "#1E90FF",
//                   bgcolor: "#111",
//                 },
//                 "& fieldset": { borderColor: "#444" },
//                 "&:hover fieldset": { borderColor: "#1E90FF" },
//                 "&.Mui-focused fieldset": { borderColor: "#1E90FF" },
//               },
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ color: "#1E90FF" }} />
//                 </InputAdornment>
//               ),
//               style: { color: "white" },
//             }}
//           />
//         </Box>

//         {/* Metrics */}
//         <Box sx={{ textAlign: "center", mb: 4 }}>
//           <Typography variant="subtitle1" sx={{ color: "#aaa" }}>
//             Displaying {experts.length} expert
//             {experts.length !== 1 ? "s" : ""}
//             {subscription?.is_active === false ? " (Free plan limit)" : ""}
//           </Typography>
//         </Box>

//         {/* Experts Container */}
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>
//           {loading
//             ? Array.from({ length: CHUNK_SIZE }).map((_, idx) => (
//                 <Card
//                   key={idx}
//                   sx={{ width: 280, borderRadius: 3, p: 2, bgcolor: "#111" }}
//                 >
//                   <Skeleton variant="circular" width={96} height={96} sx={{ mx: "auto", mt: 2 }} />
//                   <Skeleton height={30} sx={{ mt: 2 }} />
//                   <Skeleton height={20} sx={{ mt: 1 }} />
//                   <Skeleton height={20} sx={{ mt: 1 }} />
//                 </Card>
//               ))
//             : experts.map((expert, idx) => {
//                 const isLast = idx === experts.length - 1;
//                 return (
//                     <ButtonBase
//   onClick={() => navigate(`/expert-profile?expert_id=${expert.user_id}`)}
//   sx={{ borderRadius: 3 }}
// >
//                   <Card
//                     key={expert.id}
//                     ref={isLast ? lastExpertRef : null}
//                     // onClick={() => navigate(`/expert-profile?expert_id=${expert.user_id}`)}
//                     sx={{
//                       width: 280,
//                       borderRadius: 3,
//                       p: 2,
//                       textAlign: "center",
//                       bgcolor: "#111",
//                       transition: "transform 0.3s, box-shadow 0.3s",
//                       "&:hover": {
//                         transform: "translateY(-6px)",
//                         boxShadow: "0 12px 24px rgba(30,144,255,0.3)",
//                       },
//                     }}
//                   >
//                     <Avatar
//                       src={expert.image_url || ""}
//                       alt={`${expert.name} ${expert.surname}`}
//                       sx={{ width: 96, height: 96, mx: "auto", mb: 2 }}
//                     />
//                     <CardContent sx={{ p: 1 }}>
//                       <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
//                         {expert.name} {expert.surname}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: "#888" }}>
//                         {expert.designation || expert.areas_of_expertise}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                   </ButtonBase>
//                 );
//               })}
//         </Box>

//         {/* Subscription Prompt for free users */}
//         {!loading && subscription?.is_active === false && (
//           <Box
//   sx={{
//     mt: 6,
//     display: "flex",
//     justifyContent: "center",
//   }}
// >
//   <Box
//     sx={{
//       maxWidth: 500,
//       p: 3,
//       borderRadius: 3,
//       bgcolor: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
//       textAlign: "center",
//       boxShadow: "0 8px 20px rgba(30,144,255,0.3)",
//       color: "white",
//       position: "relative",
//     }}
//   >
//     {/* Optional icon */}
//     <Box sx={{ fontSize: 48, mb: 2 }}>🔒</Box>

//     <Typography sx={{ fontWeight: 600, mb: 1, fontSize: 16 }}>
//       You have reached your free expert limit.
//     </Typography>

//     <Typography sx={{ mb: 2, fontSize: 14, color: "#ccc" }}>
//       Upgrade your subscription to unlock access to all experts, full search, and more.
//     </Typography>

//     <Link
//       component="button"
//       onClick={() => navigate("/subscription-page")}
//       sx={{
//         display: "inline-block",
//         px: 4,
//         py: 1.2,
//         borderRadius: "30px",
//         fontWeight: 600,
//         color: "#fff",
//         bgcolor: "#1E90FF",
//         textDecoration: "none",
//         transition: "0.3s",
//         "&:hover": {
//           bgcolor: "#00C9FF",
//           transform: "translateY(-2px)",
//           boxShadow: "0 6px 12px rgba(0,201,255,0.4)",
//         },
//       }}
//     >
//       Subscribe Now
//     </Link>
//   </Box>
// </Box>

//         )}

//         {fetchingMore && subscription?.is_active && (
//           <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
//             <CircularProgress color="primary" />
//           </Box>
//         )}
//       </Container>
//       <Footer2 />
//     </div>
//   );
// };

// export default ExpertsPage;


import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Container, Card, CardContent, Typography, Avatar,
  Box, TextField, CircularProgress, Link, ButtonBase,
} from "@mui/material";
import {api} from "../Login/axiosConfig";
import Skeleton from "@mui/material/Skeleton";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import Platform from "../Platform/Platform";
import useDebounce from "./useDebounce"; // ← new

const API_URL = process.env.REACT_APP_API_URL;
const CHUNK_SIZE = 10;
const FREE_USER_LIMIT = 8;

const ExpertsPage = () => {
  const { userId, loggedIn } = useAuth();
  const navigate = useNavigate();

  const [experts, setExperts]           = useState([]);
  const [loading, setLoading]           = useState(true);   // true = first page load
  const [fetchingMore, setFetchingMore] = useState(false);  // true = next page load
  const [searching, setSearching]       = useState(false);  // ← NEW: isolated search loading
  const [page, setPage]                 = useState(1);
  const [hasMore, setHasMore]           = useState(true);
  const [searchTerm, setSearchTerm]     = useState("");     // raw input value (updates on every keystroke)
  const [subscription, setSubscription] = useState(null);
  const [emptyResult, setEmptyResult]   = useState(false);  // ← NEW: no results state

  // ─── DEBOUNCE ───────────────────────────────────────────────────
  // debouncedSearch only updates 400ms after the user stops typing.
  // This is what triggers the API call — NOT searchTerm directly.
  const debouncedSearch = useDebounce(searchTerm, 400);

  const observer = useRef();
  // ----------------------------------------------------------------

  // ── Subscription init ──────────────────────────────────────────
  const initSubscription = useCallback(async () => {
    if (!userId) return;
    try {
      const { data } = await api.post(`${API_URL}/subscriptions/init/`, {
        user_id: userId,
      });
      setSubscription(data.platform);
    } catch (err) {
      console.error("Failed to initialize subscription:", err);
    }
  }, [userId]);

  useEffect(() => { initSubscription(); }, [initSubscription]);

  // ── Core fetch ─────────────────────────────────────────────────
  // useCallback prevents a new function reference on every render,
  // keeping the IntersectionObserver stable.
  const loadExperts = useCallback(async (pageNumber = 1, search = "") => {
    if (!subscription) return;

    const isNewSearch = pageNumber === 1;

    // Differentiate loading states so UI doesn't fully "blink" on search
    if (isNewSearch && search) setSearching(true);    // search indicator only
    else if (isNewSearch)       setLoading(true);     // initial / clear
    else                        setFetchingMore(true);// infinite scroll

    setEmptyResult(false); // reset before every fetch

    try {
      const { data } = await api.get(`${API_URL}/experts/`, {
        params: { page: pageNumber, limit: CHUNK_SIZE, search },
      });

      const newExperts = Array.isArray(data) ? data : (data.experts ?? []);

      const limitedExperts = subscription.is_active === false
        ? newExperts.slice(0, FREE_USER_LIMIT)
        : newExperts;

      // ── Pagination reset on new search ──────────────────────
      // When pageNumber === 1, replace the list entirely.
      // On subsequent pages, append.
      setExperts(prev => isNewSearch ? limitedExperts : [...prev, ...limitedExperts]);

      setHasMore(
        subscription.is_active
          ? newExperts.length === CHUNK_SIZE
          : false
      );

      setPage(pageNumber);
      setEmptyResult(limitedExperts.length === 0); // ← flag empty results
    } catch (err) {
      console.error("Failed to fetch experts:", err);
    } finally {
      setLoading(false);
      setFetchingMore(false);
      setSearching(false);
    }
  }, [subscription]);

  // ── Trigger on debounced search OR subscription ready ─────────
  // Separating these two effects ensures:
  // 1. Initial load fires once when subscription arrives (no searchTerm yet)
  // 2. Subsequent searches fire only after the user pauses typing (debounced)
  // 3. Pagination always resets to page 1 on every new search
  useEffect(() => {
    if (subscription) loadExperts(1, debouncedSearch);
  }, [subscription, debouncedSearch]); // ← debouncedSearch, NOT searchTerm

  // ── Infinite scroll ────────────────────────────────────────────
  const lastExpertRef = useCallback((node) => {
    if (fetchingMore || !subscription?.platform?.is_active) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        // Pass debouncedSearch so scroll-pagination uses the same query
        loadExperts(page + 1, debouncedSearch);
      }
    });

    if (node) observer.current.observe(node);
  }, [fetchingMore, hasMore, page, debouncedSearch, subscription, loadExperts]);

  // ── Derived state ──────────────────────────────────────────────
  // Shows skeleton only on true initial load, not on search refetch
  const showSkeletons = loading && !searching;

  return (
    <div>
      <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1300 }}>
        <Header1 />
      </Box>
      {loggedIn && <Platform />}

      <Container maxWidth="lg" sx={{ py: 10, background: "radial-gradient(circle at top, #1b1b2b 0%, #000000 100%)" }}>

        {/* Heading */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700, letterSpacing: 4, textTransform: "uppercase",
              display: "inline-block", position: "relative",
              "&::after": {
                content: '""', position: "absolute", width: "60%", height: "4px",
                bottom: -8, left: "50%", transform: "translateX(-50%)",
                background: "linear-gradient(90deg, #1E90FF, #00C9FF)", borderRadius: 2,
              },
            }}
          >
            Our Experts
          </Typography>
        </Box>

        {/* Search Bar */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 4, px: 2 }}>
          <TextField
            placeholder="Search experts by name or skills"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} // updates raw term instantly
            sx={{
              width: "100%", maxWidth: 600, bgcolor: "#111", borderRadius: "50px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "50px", bgcolor: "#111", color: "white", transition: "0.3s",
                "&:hover": { bgcolor: "#222" },
                "&.Mui-focused": { boxShadow: "0 0 10px rgba(30, 144, 255, 0.6)", bgcolor: "#111" },
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: "#1E90FF" },
                "&.Mui-focused fieldset": { borderColor: "#1E90FF" },
              },
            }}
            InputProps={{
              // ── Inline search state indicator ──────────────────
              // Shows a spinner inside the input while debounce is pending
              // OR while the API call is in flight — no full-page re-render.
              endAdornment: (searching || searchTerm !== debouncedSearch) ? (
                <InputAdornment position="end">
                  <CircularProgress size={18} sx={{ color: "#1E90FF", mr: 1 }} />
                </InputAdornment>
              ) : null,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#1E90FF" }} />
                </InputAdornment>
              ),
              style: { color: "white" },
            }}
          />
        </Box>

        {/* Metrics */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography variant="subtitle1" sx={{ color: "#aaa" }}>
            {searching
              ? "Searching…"
              : `Displaying ${experts.length} expert${experts.length !== 1 ? "s" : ""}` +
                (subscription?.platform?.is_active === false ? " (Free plan limit)" : "")
            }
          </Typography>
        </Box>

        {/* Experts Grid */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4, justifyContent: "center" }}>

          {/* ── Skeletons: only on true initial page load ── */}
          {showSkeletons &&
            Array.from({ length: CHUNK_SIZE }).map((_, idx) => (
              <Card key={idx} sx={{ width: 280, borderRadius: 3, p: 2, bgcolor: "#111" }}>
                <Skeleton variant="circular" width={96} height={96} sx={{ mx: "auto", mt: 2 }} />
                <Skeleton height={30} sx={{ mt: 2 }} />
                <Skeleton height={20} sx={{ mt: 1 }} />
                <Skeleton height={20} sx={{ mt: 1 }} />
              </Card>
            ))
          }

          {/* ── Expert cards ── */}
          {!showSkeletons && experts.map((expert, idx) => {
            const isLast = idx === experts.length - 1;
            return (
              <ButtonBase
                key={expert.user_id}
                onClick={() => navigate(`/expert-profile?expert_id=${expert.user_id}`)}
                sx={{ borderRadius: 3 }}
              >
                <Card
                  ref={isLast ? lastExpertRef : null}
                  sx={{
                    width: 280, borderRadius: 3, p: 2, textAlign: "center", bgcolor: "#111",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: "0 12px 24px rgba(30,144,255,0.3)",
                    },
                  }}
                >
                  <Avatar
                    src={expert.image_url || ""}
                    alt={`${expert.name} ${expert.surname}`}
                    sx={{ width: 96, height: 96, mx: "auto", mb: 2 }}
                  />
                  <CardContent sx={{ p: 1 }}>
                    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                      {expert.name} {expert.surname}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#888" }}>
                      {expert.designation || expert.areas_of_expertise}
                    </Typography>
                  </CardContent>
                </Card>
              </ButtonBase>
            );
          })}

          {/* ── Empty state ─────────────────────────────────── */}
          {!showSkeletons && !searching && emptyResult && (
            <Box sx={{ width: "100%", textAlign: "center", py: 8 }}>
              <Typography sx={{ fontSize: 48, mb: 2 }}>🔍</Typography>
              <Typography variant="h6" sx={{ color: "#aaa", mb: 1 }}>
                No experts found for "{debouncedSearch}"
              </Typography>
              <Typography variant="body2" sx={{ color: "#555" }}>
                Try a different name, designation, or area of expertise.
              </Typography>
            </Box>
          )}
        </Box>

        {/* Free plan upsell */}
        {!loading && subscription?.platform?.is_active === false && (
          <Box sx={{ mt: 6, display: "flex", justifyContent: "center" }}>
            <Box sx={{
              maxWidth: 500, p: 3, borderRadius: 3, textAlign: "center",
              boxShadow: "0 8px 20px rgba(30,144,255,0.3)", color: "white",
            }}>
              <Box sx={{ fontSize: 48, mb: 2 }}>🔒</Box>
              <Typography sx={{ fontWeight: 600, mb: 1, fontSize: 16 }}>
                You have reached your free expert limit.
              </Typography>
              <Typography sx={{ mb: 2, fontSize: 14, color: "#ccc" }}>
                Upgrade your subscription to unlock all experts, full search, and more.
              </Typography>
              <Link
                component="button"
                onClick={() => navigate("/subscription-page")}
                sx={{
                  display: "inline-block", px: 4, py: 1.2, borderRadius: "30px",
                  fontWeight: 600, color: "#fff", bgcolor: "#1E90FF",
                  textDecoration: "none", transition: "0.3s",
                  "&:hover": { bgcolor: "#00C9FF", transform: "translateY(-2px)", boxShadow: "0 6px 12px rgba(0,201,255,0.4)" },
                }}
              >
                Subscribe Now
              </Link>
            </Box>
          </Box>
        )}

        {/* Infinite scroll spinner */}
        {fetchingMore && subscription?.platform?.is_active && (
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <CircularProgress color="primary" />
          </Box>
        )}

      </Container>
      <Footer2 />
    </div>
  );
};

export default ExpertsPage;